import { Axis } from '../axis';
import { DrawPass } from '../chart';
import { ChartFeature, IconLayerSpecification } from '../chart-props';

export function drawIconLayer(pass: DrawPass, features: ChartFeature[], layer: IconLayerSpecification, xAxis: Axis, yAxis: Axis) {
    if (!layer.paint.icon) {
        return;
    }

    if (layer.layout.getPosition) {
        const position = layer.layout.getPosition(features);
        if (position && position.geometry.type === 'Point') {
            pass.drawer.drawImage(
                layer.paint.icon,
                [
                    xAxis.project(position.geometry.coordinates[0], pass.viewState) + (layer.paint.offset?.[0] ?? 0),
                    yAxis.project(position.geometry.coordinates[1], pass.viewState) + (layer.paint.offset?.[1] ?? 0)
                ],
                {
                    width: layer.paint.size.width,
                    height: layer.paint.size.height
                }
            );
            return;
        }
    }

    for (let i = 0; i < features.length; i++) {
        const feature = features[i];
        if (layer.filter && !layer.filter(feature, i)) {
            continue;
        }

        if (feature.geometry.type === 'Point') {
            pass.drawer.drawImage(
                layer.paint.icon,
                [
                    xAxis.project(feature.geometry.coordinates[0], pass.viewState) + (layer.paint.offset?.[0] ?? 0),
                    yAxis.project(feature.geometry.coordinates[1], pass.viewState) + (layer.paint.offset?.[1] ?? 0)
                ],
                {
                    width: layer.paint.size.width,
                    height: layer.paint.size.height
                }
            );
        }
    }
}
